export default ['Design', 'Construction', 'Contract Negotiation', 'Document Development', 'Occupation'];
